type Item = {
  icon: string;
  desc: string;
};

type ListProps = {
  data: Item[];
  count: number;
};

type ListItemProps = {
  data: Item;
};

type GuidesKeyItemsProps = {
  data: {
    title: string;
    list: Item[][];
  };
};
const List = ({ data, count }: ListProps) => {
  const columnClass = data.length === 3 ? "three" : "four";

  return (
    <ul
      className={`card--default card--feature has-${columnClass}-col ${
        count === 0 ? "lg:mb-5" : ""
      }`}
    >
      {data.map((item, index) => (
        <ListItem key={index} data={item} />
      ))}
    </ul>
  );
};

const ListItem = ({ data }: ListItemProps) => (
  <li className="md:mb-3">
    <div className="icon-title-wrap">
      <figure dangerouslySetInnerHTML={{ __html: data.icon }} />
      <p>{data.desc}</p>
    </div>
  </li>
);

const GuidesKeyItems = ({ data }: GuidesKeyItemsProps) => (
  <section className="container">
    <h2
      className="lg:text-center md:text-left text-lg lg:mb-10 md:mb-5 md:mt-5"
      dangerouslySetInnerHTML={{ __html: data.title }}
    />
    {data.list.map((item, index) => (
      <List key={index} data={item} count={index} />
    ))}
  </section>
);

export default GuidesKeyItems;
